import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';  
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useAuth } from '../../Context/authContext'; // AuthContext'ten useAuth hook'unu import et

const theme = createTheme();

export default function SignIn() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();  
  const { login } = useAuth(); // AuthContext'ten login işlevini al

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(''); // Hata mesajını sıfırla

    try {
      await login(username, password); // Giriş işlemini AuthContext üzerinden yap

      navigate('/admin'); 
      window.location.href = '/admin' // Başarılıysa admin sayfasına yönlendir
    } catch (err) {
      console.error(err);
      setError('Giriş başarısız. Lütfen bilgilerinizi kontrol ediniz.'); // Hata mesajını göster
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs" sx={{pt:25 , pb:15}}>
        <CssBaseline />
        <Box sx={{justifyItems:"center", justifyContent:"center"}}
        >
          <Typography component="h1" variant="h5" sx={{justifyContent:"center"}} >
            Admin Girişi
          </Typography>
          <Box component="form" noValidate sx={{ mt: 1 }} onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Kullanici Adi"
              name="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Şifre"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Giriş Yap
            </Button>
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
